import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';

/**
 * Story 9.2 (AC-9.2.2/3/7a): gates the public user-management routes on the per-(application, tenant)
 * `tenant_admin` claim decoded from the current stage-2 access token (replacing the global isAdmin
 * gate). The route guard is convenience only — the backend enforces the live Admission.TenantAdmin
 * check on every request (AC-9.2.3).
 */
export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const sessionService = inject(SessionService);
  const router = inject(Router);
  const user = authService.currentUser();

  if (!user) {
    return router.createUrlTree(['/sign-in']);
  }

  if (route.data['requireAdminRole']) {
    return sessionService.isTenantAdmin() ? true : router.createUrlTree(['/sign-in']);
  }

  return true;
};
